import EventBroker from "../../scripts/eventBroker";

const eventBroker = new EventBroker("calendar-v2")

export default eventBroker;